import React from 'react';
import { node, string } from 'prop-types';
import { Tag } from '@fiverr-private/fit';

const NewBadge = ({ className, title }) => (
    <Tag className={className}
        size={Tag.SIZES.TINY}
        theme={Tag.THEMES.HOLLOW}
        color={Tag.COLORS.BLUE}>
        {title}
    </Tag>
);

NewBadge.propTypes = {
    className: string,
    title: node
};

export default NewBadge;
